import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import POSMain from "../pages/POSMain";
import axios from "axios";
import { apiKey } from "../config/config";

export default function POSLayout() {
  const navigate = useNavigate();
  const [outletData, setOutletData] = useState();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("rms-admin"));

    if (!user) {
      navigate("/admin");
    }


    axios.get(`${apiKey}/api/rms/admin/get-outlets/${user?.user?.outlet_id}`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    }).then((res) => {
      setOutletData(res.data && res.data[0]);
    }).catch((err) => { })

  }, [navigate]);
  return (
    <>
      <Routes>
        <Route path="/main" element={<POSMain outletData={outletData} />} />
      </Routes>
    </>
  );
}
